import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyAQAcH9VQx7WvDjJzZ5nxvm-WrEituOQz4",
    authDomain: "tailwindblower.firebaseapp.com",
    databaseURL: "https://tailwindblower.firebaseio.com",
    projectId: "tailwindblower",
    storageBucket: "tailwindblower.appspot.com",
    messagingSenderId: "511944404970",
    appId: "1:511944404970:web:13a5e3804a7975a5a08c93",
    measurementId: "G-BEBPK9SN1Y"
  };

const firebaseApp = firebase.initializeApp(firebaseConfig);

// const db = firebaseApp.firestore();
// const auth = firebaseApp.auth();
// const storage = firebaseApp.storage();
const analytic = firebaseApp.analytics();
// if (document.location.hostname === "localhost") {
//   db.settings({
//     host: "localhost:8080",
//     ssl: false,
//   });
// }
export { analytic };
